import React, {Component} from "react";
import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import $ from "jquery";
import {css} from "@emotion/core";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from "react-awesome-modal";
import {connect}  from  "react-redux";
import axios from "axios";
import {Link} from "react-router-dom";
import Switch from "react-switch";
import {BeatLoader} from 'react-spinners';
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align: center;
`;
function formatNumber(num) {
    //return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    var n1, n2;
    num = num + '' || '';
    // works for integer and floating as well
    n1 = num.split('.');
    n2 = n1[1] || null;
    n1 = n1[0].replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
    num = n2 ? n1 + '.' + n2 : n1;
    return num;
}
var todayDate = new Date();
var timestamp  = new Date().getTime();
var yesterday = new Date(Date.now() - 24*60*60*1000);
var tod = moment(yesterday).format('MM/DD/YYYY');
var yest = moment(yesterday).format('MM/DD/YYYY');
var todShow = moment(yesterday).format('D MMM YYYY');
var yestShow = moment(yesterday).format('D MMM YYYY');
var todSend = moment(yesterday).format('YYYY-MM-DD');
var yestSend = moment(yesterday).format('YYYY-MM-DD');
var date_limit = moment(yesterday).format('MM/DD/YYYY');
Array.prototype.move = function(from,to){
    this.splice(to,0,this.splice(from,1)[0]);
    return this;
};

function enabledBody() {
    $('body').removeClass("back-disabled");
}

function disabledBody() {
    $('body').addClass("back-disabled");
}
function MergeGridCells() {
    var dimension_cells = new Array();
    var dimension_col = null;
    var columnCount = $("#PoserAggr tr:first th").length;
    //alert(columnCount)
    for (dimension_col = 0; dimension_col <= 1; dimension_col++) {
        // first_instance holds the first instance of identical td
        var first_instance = null;
        var rowspan = 1;
        // iterate through rows
        $("#PoserAggr").find('tr').each(function () {
            //console.log("sssssss");

            // find the td of the correct column (determined by the dimension_col set above)
            var dimension_td = $(this).find('td:nth-child(' + dimension_col + ')');



            if (first_instance === null) {
                // must be the first row
                first_instance = dimension_td;
            } else if (dimension_td.text() === first_instance.text()) {
                // the current td is identical to the previous
                // remove the current td
                // dimension_td.remove();
                dimension_td.attr('hidden', true);
                ++rowspan;
                // increment the rowspan attribute of the first instance
                first_instance.attr('rowspan', rowspan);
            } else {
                // this cell is different from the last
                first_instance = dimension_td;
                rowspan = 1;
            }
        });
    }
}
class PoserDetails extends Component{
    constructor(props) {
        super(props);
        this.state ={
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            loading:true,
            model_visible : false,
            file_url: '',
            rfile: '',
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            tableHeaders:[],
            tableBody:[],
            num_of_column:[],
            isChange:false,
            merchantID:'',
            tender_mode:'',
            transaction_type:'',
            error_groups:''

        }
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        }
    componentDidMount() {
        this.subMenuPermission();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            user_id:decoded._id
        });
        let sdate = this.state.yestSend;
        let tdate = this.state.todSend;
        let merchants = this.state.merchantID;
        let tender_mode = this.state.tender_mode;
        let transaction_type = this.state.transaction_type;
        let error_group = this.state.error_groups;


        if(localStorage.start_datec!==undefined){
            let ms = localStorage.merchantsc;
            let tm = localStorage.tender_modec;
            let tt = localStorage.transaction_typec;
            let eg = localStorage.error_groupc;
            if(ms!=""){
                ms=ms.split(",")
            }
            if(tm!=""){
                tm=tm.split(",")
            }
            if(tt!=""){
                tt=tt.split(",")
            }
            if(eg!=""){
                eg=eg.split(",")
            }
            sdate = localStorage.start_datec
            tdate = localStorage.end_datec
            merchants = ms
            tender_mode = tm
            transaction_type = tt
            error_group = eg
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: decoded.object_code,
            yestSend:sdate,
            todSend:tdate,
            merchantID:merchants,
            tender_mode:tender_mode,
            transaction_type: transaction_type,
            error_groups: error_group

        });
        setTimeout(function(){
            this.get_poser_details_report();
        }.bind(this), 200);

        if(decoded.object_type=='Admin' || decoded.object_type=='Innoviti') {

            //this.get_filtered_poser_report();

            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
            })
        }
        else if(decoded.object_type=='Merchant') {
            var merchantData = [{"value":decoded.object_code, "label":""}]
            //this.changeMerchant(merchantData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
            })
            //this.get_poser_report('', this.state.yestSend, this.state.todSend)
        }
        else if(decoded.object_type=='Chain') {
            //this.getStore(decoded.object_code, 'chain', decoded.object_type, decoded.object_code);
            var chainData = [{"value":decoded.object_code, "label":""}]
            //this.changeChain(chainData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: true,
                acq_bank_list_box: true,
            })
            //this.get_poser_report('', this.state.yestSend, this.state.todSend)
        }
        else if(decoded.object_type=='Store') {
            var storeData = [{"value":decoded.object_code, "label":""}]
            //this.changeStore(storeData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: false,
                acq_bank_list_box: true,
            })
            //this.get_poser_report('', this.state.yestSend, this.state.todSend)
        }

        else {
            this.unauthorize_access();
        }

    }
    subMenuPermission(){
        const token = localStorage.usertoken;
        let subMenuPermissions = [];
        let reportPermissions = [];
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        AllAccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Submenu'){
                subMenuPermissions.push(permissionName.access_name);
            }
            if(permissionName.access_type=='report'){
                reportPermissions.push(permissionName.access_name);
            }
        });
        if(reportPermissions.includes("poser_report")===false ){
            this.unauthorize_access();
        }
    }
    unauthorize_access(){
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";
    }

    get_poser_details_report(){
        var that = this;
        disabledBody()

        var postData = {
            mids: this.state.merchantID,
            error_group: this.state.error_groups,
            tender_mode: this.state.tender_mode,
            transaction_type: this.state.transaction_type,
            start_date: this.state.yestSend,
            end_date: this.state.todSend,


        };
        if ($.fn.DataTable.isDataTable('#PoserDetailsTable')) {
            $('#PoserDetailsTable').DataTable().clear().destroy();
        }
        var PoserDetailsTable = $('#PoserDetailsTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                //"autoWidth": false,
                "responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/summaryReport/poser-details",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        enabledBody();
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        enabledBody()
                    },
                    complete: function (data) {
                        enabledBody()
                    },
                },

                columns: [

                    {"data":"Merchant"},
                    {"data":"Chain"},
                    {"data":"Store"},
                    {"data":"PRIM id"},
                    {"data":"Transaction Date"},
                    {"data":"Transaction Time"},
                    {"data":"Utid"},
                    {"data":"Btid"},
                    {"data":"Txn Amount"},
                    {"data":"Masked Card Number"},
                    {"data":"BIN"},
                    {"data":"EMI Bank Code"},
                    {"data":"Acquiring Bank"},
                    {"data":"Issuer Bank"},
                    {"data":"Scheme"},
                    {"data":"Grade"},
                    {"data":"Communication Id"},
                    {"data":"Tender Mode"},
                    {"data":"Credit/Debit"},
                    {"data":"Transaction Type"},
                    {"data":"Approval Code"},
                    {"data":"RRN No"},
                    {"data":"UPI Txn ID"},
                    {"data":"Batch srl"},
                    {"data":"Merchant Invoice Number"},
                    {"data":"Processing Code"},
                    {"data":"Is DCC Transaction"},
                    {"data":"Is International Card"},
                    {"data":"Software Version"},
                    {"data":"Terminal Serial Number"},
                    {"data":"Addional Info1"},
                    {"data":"Addional Info2"},
                    {"data":"CI Inno Response Code"},
                    {"data":"BI Bank Response Code"},
                    {"data":"BO Bank Response Code"},
                    {"data":"CO Inno Response Code"},
                    {"data":"CO Reason Code"},
                    {"data":"CO Reason Message"},
                    {"data":"UFE Message"},

                ],
                // "columnDefs": [
                //     {  render: function (data) {
                //             return '<td >'+moment(data).format('D MMM YYYY')+'</td>';
                //         },
                //         "width": "80px",
                //         "targets": 5
                //     },
                //
                // ],

            });
    }
    handleEvent(event, picker, e) {
        this.setState({
            todSend: moment(picker.endDate).format('YYYY-MM-DD'),
            yestSend: moment(picker.startDate).format('YYYY-MM-DD'),
            datefromShow: moment(picker.startDate).format('D MMM YYYY'),
            dateToShow: moment(picker.endDate).format('D MMM YYYY')
        });
        if(event.type=='apply'){
            this.setState({
                isChange:true
            })
        }
    }



    poser_report_download (type, e){
        this.setState({
            is_download: false,
            model_visible: true,
            file_url: '',
            rfile: ''
        });
        var postData = {
            mids: this.state.merchantID,
            tender_mode: this.state.tender_mode,
            transaction_type: this.state.transaction_type,
            start_date: this.state.yestSend,
            end_date: this.state.todSend,
            type:type,
            download: 1,
            error_group: this.state.error_groups,
        };

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/summaryReport/poser-download",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "application/csv"
                });
                let fileName = timestamp+type+'.csv.gz';
                let rfile = fileName.replace(/\"/g, "");
                //console.log(fileName)
                //let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                // a.href = url;
                // a.download = rfile;
                // a.click();
                // window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true,
                    file_url: url,
                    rfile: rfile
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    downloadFile(e){ //alert(this.state.file_url);
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.file_url);
    }
    closeModal() {
        this.setState({
            model_visible : false
        });
    }
    reset_all(e){
        this.setState({
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            isChange:true
        })

        setTimeout(function(){
            this.componentDidMount()
        }.bind(this), 200);
    }
    render() {

        return(

            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">POSER Details</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>

                                <div className = "clearfix"></div>
                                <div className = "content">

                                    <div className="clearfix"></div>

                                    {/*<div className="emi-zone-head">POSER Details</div>*/}
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.poser_report_download.bind(this, 'poser_details')}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="PoserDetailsTable" className="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <th>Merchant</th>
                                                <th>Chain</th>
                                                <th>Store</th>
                                                <th>PRIM id</th>
                                                <th>Transaction Date</th>
                                                <th>Transaction Time</th>
                                                <th>Utid</th>
                                                <th>Btid</th>
                                                <th>Txn Amount</th>
                                                <th>Masked Card Number</th>
                                                <th>BIN</th>
                                                <th>EMI Bank Code</th>
                                                <th>Acquiring Bank</th>
                                                <th>Issuer Bank</th>
                                                <th>Scheme</th>
                                                <th>Grade</th>
                                                <th>Communication Id</th>
                                                <th>Tender Mode</th>
                                                <th>Credit/Debit</th>
                                                <th>Transaction Type</th>
                                                <th>Approval Code</th>
                                                <th>RRN No</th>
                                                <th>UPI Txn ID</th>
                                                <th>Batch srl</th>
                                                <th>Merchant Invoice Number</th>
                                                <th>Processing Code</th>
                                                <th>Is DCC Transaction</th>
                                                <th>Is International Card</th>
                                                <th>Software Version</th>
                                                <th>Terminal Serial Number</th>
                                                <th>Addional Info1</th>
                                                <th>Addional Info2</th>
                                                <th>CI Inno Response Code</th>
                                                <th>BI Bank Response Code</th>
                                                <th>BO Bank Response Code</th>
                                                <th>CO Inno Response Code</th>
                                                <th>CO Reason Code</th>
                                                <th>CO Reason Message</th>
                                                <th>UFE Message</th>

                                            </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>

                                    <ModalD visible={this.state.model_visible} width="300" height="100" effect="fadeInUp">
                                        <div className="download-popup-model">
                                            <div className="message-content">
                                                {this.state.file_url==''?
                                                    <div>
                                                        <p>Generating CSV...</p>
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                                        </a>
                                                    </div>
                                                    :
                                                    <div className="dwnloadLink">
                                                        <a href="#" onClick={this.downloadFile.bind(this)}>
                                                            <i className="fa fa-download" aria-hidden="true"></i>Download
                                                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </ModalD>
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)(PoserDetails)